import React, { forwardRef } from 'react';

import { Icon } from '@column/column-ui-kit';
import { cn } from '@column/ui';

interface SelectorTriggerProps extends React.ComponentProps<'button'> {
  label: string;
  hasError?: boolean;
}

export const SelectorTrigger = forwardRef<HTMLButtonElement, SelectorTriggerProps>(
  ({ label, hasError, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-invalid={hasError || undefined}
      className={cn(
        'flex h-10 w-full cursor-pointer items-center justify-between gap-2 rounded-lg bg-white px-4 py-2',
        'text-sm font-medium text-gray-400 shadow-btn-secondary transition-[color,box-shadow,opacity] duration-150 outline-none',
        'hover:shadow-btn-secondary-hover focus-visible:shadow-[0_0_0_1px_var(--color-blue-500)] focus-visible:ring-[3px] focus-visible:ring-blue-500/15',
        'dark:bg-input/30 dark:shadow-[0_0_0_1px_rgb(255_255_255/0.15)] dark:hover:shadow-[0_0_0_1px_rgb(255_255_255/0.25)]',
        // The popover opens on top of the trigger; hide it so their shadows don't stack.
        'data-[state=open]:opacity-0',
        hasError &&
          'bg-destructive/[0.025] shadow-invalid hover:shadow-invalid dark:bg-destructive/5 dark:shadow-invalid dark:hover:shadow-invalid',
        className
      )}
      {...props}
    >
      <span className="min-w-0 flex-1 truncate text-left">{label}</span>
      <Icon.ChevronDown
        className={cn(
          'shrink-0 transition-colors [--icon-size:16px]',
          hasError ? 'text-invalid' : 'text-muted-foreground'
        )}
      />
    </button>
  )
);
SelectorTrigger.displayName = 'SelectorTrigger';
